'use client';

import { RefObject, useState, useMemo, useEffect } from 'react';

export function useOnScreen(ref: RefObject<HTMLElement>) {
	const [isIntersecting, setIntersecting] = useState(false);

	const observer: null | IntersectionObserver = useMemo(() => {
		if (typeof window === 'undefined') {
			return null;
		}

		return new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));
	}, [ref]);

	const disconnect = () => {
		observer?.disconnect();
	};

	useEffect(() => {
		if (!ref?.current) {
			return;
		}

		observer?.observe(ref.current);
		return () => observer?.disconnect();
	}, []);

	return { onScreen: isIntersecting, disconnect };
}
